import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  min-height: 100vh;

  > header {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 55px;
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 10;
    border-bottom: 0.5px solid #d8dee5;

    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80%;

      span {
        text-align: center;
        font-weight: 500;
        font-size: 16px;
        color: #000000;
      }
    }

    .div-space {
      width: 10%;
      height: 100%;

      > img {
        width: 10px;
        height: 35px;
        margin-left: 22px;
        cursor: pointer;
      }
    }
  }
`;

export const Body = styled.div`
  display: flex;
  margin-top: 55px;
  padding: 32px 24px;
  flex-direction: column;
  align-items: center;
`;

export const InfoCard = styled.div`
  background: #f0f7ff;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  width: 100%;
  max-width: 480px;

  > h2 {
    font-size: 20px;
    font-weight: 600;
    color: #000;
    margin-bottom: 12px;
  }

  > p {
    font-size: 14px;
    line-height: 20px;
    color: #4a4a4a;
    margin-bottom: 8px;
  }
`;

export const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 16px 0;
  width: 100%;
  max-width: 480px;

  > li {
    display: flex;
    align-items: center;
    padding: 10px 0;
    font-size: 14px;
    color: #333;

    &::before {
      content: '✓';
      color: #2b8ff5;
      font-weight: bold;
      margin-right: 10px;
      font-size: 16px;
    }
  }
`;

export const StartButton = styled.button`
  background: #2b8ff5;
  color: #fff;
  border: none;
  padding: 14px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  max-width: 480px;
  margin-top: 8px;

  &:hover {
    background: #1a7de0;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const RetryButton = styled.button`
  background: none;
  color: #2b8ff5;
  border: 1px solid #2b8ff5;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 16px;
  width: 100%;
  max-width: 480px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ProgressSection = styled.div`
  width: 100%;
  max-width: 480px;
  margin-top: 8px;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: #e5e5e5;
  border-radius: 4px;
  overflow: hidden;
  margin: 16px 0 8px;

  > div {
    height: 100%;
    background: #2b8ff5;
    border-radius: 4px;
    transition: width 0.5s ease;
  }
`;

export const StepInfo = styled.p`
  font-size: 13px;
  color: #9d9d9d;
  margin: 0;
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid #e5e5e5;
  border-top-color: #2b8ff5;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  margin: 24px auto;
`;

export const SuccessCard = styled.div`
  background: #f0faf0;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 480px;
  text-align: center;

  > h2 {
    font-size: 20px;
    font-weight: 600;
    color: #2d8f2d;
    margin-bottom: 12px;
  }

  > p {
    font-size: 14px;
    color: #4a4a4a;
    margin-bottom: 16px;
  }

  > a {
    display: inline-block;
    background: #2b8ff5;
    color: #fff;
    text-decoration: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
  }
`;

export const ErrorCard = styled.div`
  background: #fff0f0;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 480px;
  text-align: center;

  > h2 {
    font-size: 18px;
    font-weight: 600;
    color: #cc3333;
    margin-bottom: 8px;
  }

  > p {
    font-size: 14px;
    color: #4a4a4a;
    margin-bottom: 4px;
  }
`;
